// The invite email's link (SM-968): a new staff member chooses a password.
import { createFileRoute } from "@tanstack/react-router";
import { PasswordLinkPage } from "@/components/auth/PasswordLinkPage";

export const Route = createFileRoute("/set-password")({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === "string" && search.token !== "" ? search.token : undefined,
  }),
  component: SetPasswordPage,
});

function SetPasswordPage() {
  const { token } = Route.useSearch();
  return <PasswordLinkPage purpose="set" token={token} />;
}
